/**
 * The once-per-browser flag for the first-visit intro tour (ISSUE-1406, v1's
 * `onboarding_seen` in local storage, the phone's `sm.welcome.introTourSeen`
 * in expo-secure-store). It lives in `localStorage` under the same key, and
 * every read and write swallows its own failure.
 *
 * Read synchronously, because the root route decides in `beforeLoad` whether
 * a signed-out visitor sees the tour or sign-in, before anything paints.
 */
export const INTRO_TOUR_SEEN_KEY = "sm.welcome.introTourSeen";

export function isIntroTourSeen(): boolean {
  try {
    return window.localStorage.getItem(INTRO_TOUR_SEEN_KEY) === "yes";
  } catch {
    // Storage the browser refuses (a locked down private window) reads as
    // seen: a tour on every visit would be worse than none at all.
    return true;
  }
}

export function markIntroTourSeen(): void {
  try {
    window.localStorage.setItem(INTRO_TOUR_SEEN_KEY, "yes");
  } catch {
    // Nothing to do: the worst case is the tour once more next visit.
  }
}
